import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import EmptySlot from './EmptySlot';
import PostContent from './PostContent';

const QueueItems = ({
  items,
  type,
  pinned,
  onEmptySlotClick,
  onCalendarClick,
  onCreatePostClick,
  shouldRenderCalendarButtons,
  shouldHideCreatePostButton,
  timezoneItems,
  isCampaign,
  ...propsForPosts
}) => {
  if (items.length === 0) {
    const item = {
      text: null,
      dayOfWeek: null,
      date: null,
      id: null,
    };
    return (
      <Header
        item={item}
        isFirstItem
        onCalendarClick={onCalendarClick}
        onCreatePostClick={onCreatePostClick}
        timezoneItems={timezoneItems}
        shouldRenderCalendarButtons={shouldRenderCalendarButtons}
        shouldHideCreatePostButton={shouldHideCreatePostButton}
      />
    );
  }

  return items.map((item, index) => {
    const { queueItemType, slot, ...rest } = item;

    let QueueSection = null;

    switch (queueItemType) {
      case 'header':
        QueueSection = (
          <Header
            key={`header-${item.id}`}
            item={rest}
            isFirstItem={index === 0}
            onCalendarClick={onCalendarClick}
            onCreatePostClick={onCreatePostClick}
            timezoneItems={timezoneItems}
            shouldRenderCalendarButtons={shouldRenderCalendarButtons}
            shouldHideCreatePostButton={shouldHideCreatePostButton}
          />
        );
        break;
      case 'post':
        QueueSection = (
          <PostContent
            key={`post-content-${item.id}`}
            index={index}
            post={rest}
            queueType={type}
            isCampaign={isCampaign}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...propsForPosts}
          />
        );
        break;
      case 'slot': {
        const isStories = type === 'stories';
        QueueSection = (
          <EmptySlot
            key={`empty-slot-${item.id}`}
            item={item}
            pinned={pinned}
            customLabel={isStories ? 'Add to Story' : null}
            customHoverMessage={isStories ? 'Schedule a Story' : null}
            onEmptySlotClick={onEmptySlotClick}
          />
        );
        break;
      }
      default:
        break;
    }

    return QueueSection;
  });
};

QueueItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
  pinned: PropTypes.bool,
  type: PropTypes.string,
  shouldRenderCalendarButtons: PropTypes.bool,
  onEmptySlotClick: PropTypes.func,
  onCalendarClick: PropTypes.func,
  shouldHideCreatePostButton: PropTypes.bool,
  isCampaign: PropTypes.bool,
  timezoneItems: PropTypes.shape({
    onTimezoneClick: PropTypes.func,
    profileTimezone: PropTypes.string,
    shouldDisplayTimezone: PropTypes.bool,
  }),
};

QueueItems.defaultProps = {
  items: [],
  shouldHideCreatePostButton: false,
  type: 'post',
  onEmptySlotClick: () => {},
  onCalendarClick: () => {},
  pinned: false,
  isCampaign: false,
  timezoneItems: {},
};

export default QueueItems;
